import React, { useState, useEffect } from 'react'

// import SmartHighlighter from "../shared/smart-words-highlight"

import _, { isEmpty } from 'lodash'

interface IImageViewProps {
    src: string
    originalSrc: string
    customClass: string
    enclosureText?: string[]
    olrDetails?: any
    objectType?: number
    mediaType?: number
    highlightWords?: {
        anchorKeywords: string[]
        contextWords: string[]
        smartBarKeywords: string[]
    }
    messageID: number
    videoDuration?: any
    isOlrItem?: boolean
    onSelectImage: (src: string, id: number) => void
    onLoaded?: (success: boolean) => void
}

const ImageView = (props: IImageViewProps) => {
    const {
        src,
        originalSrc,
        customClass,
        enclosureText,
        olrDetails,
        messageID,
        objectType,
        videoDuration,
        isOlrItem,
        highlightWords,
        onSelectImage,
        onLoaded,
    } = props
    const [isLoaded, setImageLoad] = useState<boolean>(false)
    const [viewSource, setViewSource] = useState<string | null>(null)
    const [ocrData, setOcrData] = useState<any>(null)
    let tooltipsContainerRef: HTMLElement | null

    useEffect(() => {
        if (
            typeof tooltipsContainerRef == 'undefined' ||
            tooltipsContainerRef == null
        ) {
            tooltipsContainerRef = document.getElementById(
                'tooltips-main-container'
            )
        }
    })

    useEffect(() => {
        prepareImageView()
    }, [src])

    const prepareImageView = () => {
        setViewSource(src)
        setOcrData(null)
        setImageLoad(false)

        if (enclosureText) {
            let parsedData = enclosureText.map((et) => {
                if (et[0] == '{' && et[et.length - 1] == '}') {
                    return JSON.parse(et)
                } else {
                    return null
                }
            })

            parsedData = parsedData.filter((pd) => {
                return pd !== null
            })

            if (parsedData) {
                const findOcr = parsedData.find((el) => {
                    return (
                        el.url == originalSrc ||
                        el.Url == originalSrc ||
                        el.URL == originalSrc
                    )
                })

                if (findOcr) {
                    findOcr.recognizeTypes = []
                    findOcr.recognizeDescription = null

                    setOcrData(findOcr)

                    prepareHighlightTypes(findOcr)
                } else {
                    setOcrData(null)
                }
            }
        } else {
            setOcrData(null)
        }

        if (olrDetails) {
            var a = 0
        }
    }

    useEffect(() => {
        prepareHighlightTypes(ocrData)
    }, [highlightWords])

    const prepareHighlightTypes = (data: any) => {
        if (
            data &&
            data.Text &&
            data.Text !== '' &&
            highlightWords &&
            enclosureText
        ) {
            let ocrDataCopy = { ...data }
            ocrDataCopy.recognizeTypes = []
            ocrDataCopy.recognizeDescription = {}

            highlightWords.anchorKeywords?.forEach((a) => {
                if (ocrDataCopy.Text.toLowerCase().includes(a.toLowerCase())) {
                    ocrDataCopy.recognizeTypes.push('anchor')

                    if (ocrDataCopy.recognizeDescription?.anchor?.keywords) {
                        ocrDataCopy.recognizeDescription.anchor.keywords.push(a)
                    } else {
                        ocrDataCopy.recognizeDescription.anchor = {
                            keywords: [a],
                        }
                    }
                }
            })

            if (ocrDataCopy.recognizeDescription?.anchor?.keywords) {
                ocrDataCopy.recognizeDescription.anchor.description = `Image contains anchor keyword${
                    ocrDataCopy.recognizeDescription.anchor.keywords.length > 1
                        ? 's'
                        : ''
                } "${ocrDataCopy.recognizeDescription.anchor.keywords.join('', '')}".`
            }

            highlightWords.contextWords?.forEach((c) => {
                if (ocrDataCopy.Text.toLowerCase().includes(c.toLowerCase())) {
                    ocrDataCopy.recognizeTypes.push('context')

                    if (ocrDataCopy.recognizeDescription?.context?.keywords) {
                        ocrDataCopy.recognizeDescription.context.keywords.push(
                            c
                        )
                    } else {
                        ocrDataCopy.recognizeDescription.context = {
                            keywords: [c],
                        }
                    }
                }
            })

            if (ocrDataCopy.recognizeDescription?.context?.keywords) {
                ocrDataCopy.recognizeDescription.context.description = `Image contains context keyword${
                    ocrDataCopy.recognizeDescription.context.keywords.length > 1
                        ? 's'
                        : ''
                } "${ocrDataCopy.recognizeDescription.context.keywords.join('', '')}".`
            }

            highlightWords.smartBarKeywords?.forEach((s) => {
                if (ocrDataCopy.Text.toLowerCase().includes(s.toLowerCase())) {
                    ocrDataCopy.recognizeTypes.push('smartbar')

                    if (ocrDataCopy.recognizeDescription?.smartbar?.keywords) {
                        ocrDataCopy.recognizeDescription.smartbar.keywords.push(
                            s
                        )
                    } else {
                        ocrDataCopy.recognizeDescription.smartbar = {
                            keywords: [s],
                        }
                    }
                }
            })

            if (ocrDataCopy.recognizeDescription?.smartbar?.keywords) {
                ocrDataCopy.recognizeDescription.smartbar.description = `Image contains search term${
                    ocrDataCopy.recognizeDescription.smartbar.keywords.length >
                    1
                        ? 's'
                        : ''
                } "${ocrDataCopy.recognizeDescription.smartbar.keywords.join('', '')}".`
            }

            if (isEmpty(ocrDataCopy.recognizeDescription)) {
                ocrDataCopy.recognizeDescription = null
            }

            ocrDataCopy.recognizeTypes = _.uniq(ocrDataCopy.recognizeTypes)
            setOcrData(ocrDataCopy)
        }
    }

    const handlePreviewError = () => {
        // console.log('error')
        setViewSource(null)
    }

    const clickByImage = () => {
        onSelectImage(originalSrc, messageID)
    }

    const onLoadedImage = () => {
        setImageLoad(true)
        onLoaded && onLoaded(true)
    }

    // console.log(viewSource, 'view')

    return (
        <div className="image-wrapper">
            {viewSource && viewSource !== '' ? (
                <>
                    <img
                        src={viewSource}
                        className={customClass}
                        loading="lazy"
                        style={{
                            maxHeight: '130px',
                            maxWidth: '100%',
                            borderRadius: '4px',
                            backgroundColor: '#fff',
                            opacity: 0.8,
                            transition: '0.3s',
                            ...(isLoaded
                                ? {}
                                : {
                                      position: 'absolute',
                                      visibility: 'hidden',
                                  }),
                        }}
                        onError={handlePreviewError}
                        onClick={clickByImage}
                        onLoad={onLoadedImage}
                        alt=""
                    />
                    {objectType &&
                    objectType === 4 &&
                    viewSource &&
                    isLoaded ? (
                        <div
                            className="play-marker element-wrapper center-align position-absolute"
                            onClick={clickByImage}
                        >
                            <i className="fas fa-play"></i>
                        </div>
                    ) : null}
                </>
            ) : null}
            {/* <div className="recognized-markers element-wrapper allow-new-line">
    </div> */}
            {videoDuration ? (
                <span className="video-duration">{videoDuration}</span>
            ) : null}
        </div>
    )
}

export default ImageView
